import React from "react";
import GoToTop from "../GoToTop";
import { Alert } from "react-bootstrap";

function Contact() {
  return (
    <>
      <GoToTop />
      <section style={{ marginTop: "-60px" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3591.117892719786!2d93.41017227540276!3d25.832660277307422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x374593de7d53806f%3A0xa4e4ff61b7e5045!2sKarbi%20Lammet%20Amei%20(KLA)!5e0!3m2!1sen!2sin!4v1767882362430!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: "0" }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>

        <div className="connectus container">
          <div className="header">
            <h1 className="title">Get in Touch</h1>
            <p className="subtitle">
              We'd love to hear from you. Drop us a line and we'll get back to
              you shortly.
            </p>
          </div>

          {/* <Alert variant="success">
            ✨ Thank you! Your message has been sent successfully. We'll get
            back to you soon.
          </Alert> */}

          <form id="contactForm" novalidate>
            <div className="form-group double">
              <div className="floating-label mb-2">
                <label for="Name">Full Name</label>
                <input
                  className="form-control"
                  type="text"
                  id="Name"
                  name="Name"
                  placeholder=" "
                  required
                />
                <div className="error-message">
                  Please enter your full name
                </div>
              </div>
           
            </div>

            <div className="form-group floating-label mb-2">
              <label for="email">Email Address</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                placeholder=" "
                required
              />
              <div className="error-message">
                Please enter a valid email address
              </div>
            </div>

            <div className="form-group floating-label mb-2">
              <label for="message">Your Message</label>
              <textarea
                id="message"
                className="form-control"
                name="message"
                placeholder=" "
                required
              ></textarea>
              <div className="error-message">Please enter your message</div>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              id="submitBtn"
            >
              Send Message
            </button>

            <div className="form-footer">
              <p>We typically respond within 24 hours</p>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}

export default Contact;
